// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"85f25305","1319":"b226c659","1840":"b226c659","2936":"6c7b3e7f"}[chunkId] + ".chunk.css";
};